import './action-bar.scss';

import { defineComponent } from 'vue';
import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { faCircle as faSolidCircle, faCogs, faHome } from '@fortawesome/free-solid-svg-icons';
import { MapIconToggle } from './map-icon-toggle';

import { TrackingRoutes } from '@skinsoft/const';
import { MovementDataStore, TaskDataStore } from '@skinsoft/entity';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { BarcodeReaderToggle } from './barcode-reader-toggle';
import { UPDATE_NUMBER_OF_HIGHLIGHTS_TOPIC } from '../../../busTopics';

export const ActionBar = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sBarcodeReaderToggle: BarcodeReaderToggle,
        sMapIconToggle: MapIconToggle
    },
    template: require('./action-bar.html'),
    props: ['hasItemFocus'],
    data() {
        return {
            homeIcon: faHome,
            menuIcon: faCogs,
            circleIcon: faCircle,
            solidCircleIcon: faSolidCircle,
            movementCount: 0,
            taskCount: 0,
            menuOpened: false,
            routeHasMenu: false,
            COMPONENT_WITH_ACTIVE_SCANNERS: ['movement'],
        }
    },
    created() {
        this.onClick = this.onClick.bind(this);
        this.updateMenuNumber()
        this.subscribeToBus(UPDATE_NUMBER_OF_HIGHLIGHTS_TOPIC, this.updateMenuNumber)
    },
    beforeUnmount() {
        this.unsubscribeFromClick();
    },
    computed: {
        canScan(): boolean {
            return this.hasItemFocus && !!this.$route.name && this.COMPONENT_WITH_ACTIVE_SCANNERS.includes(this.$route.name as string)
        },
    },
    watch: {
        '$route': {
            handler($route) {
                this.routeHasMenu = !!$route.matched.find(match => !!match.components.actionMenu);
            },
            immediate: true,
            deep: true,
        },
        routeHasMenu: {
            handler(routeHasMenu) {
                if (routeHasMenu) {
                    this.subscribeToClick();
                } else {
                    this.unsubscribeFromClick();
                }
            },
            immediate: false,
            deep: false,
        },
    },
    methods: {
        updateMenuNumber() {
            this.subscribeTo(
                (this.$movementDataStore as MovementDataStore).fetchAll({
                    query: { states: MovementDataStore.highlightStates },
                    userScope: true,
                }),
                movements => (this.movementCount = movements.length),
                'movements',
            );

            this.subscribeTo(
                (this.$taskDataStore as TaskDataStore).fetchAll({
                    query: { states: TaskDataStore.highlightStates },
                    userScope: true,
                }),
                tasks => (this.taskCount = tasks.length),
                'tasks',
            );
        },

        goToTasks() {
            this.$router.push({ name: TrackingRoutes.TASKS });
        },

        goToMovements() {
            this.$router.push({ name: TrackingRoutes.MOVEMENTS });
        },

        goToContainers() {
            this.$router.push({ name: TrackingRoutes.CONTAINERS })
        },

        goToDashboard() {
            this.$router.push({ name: TrackingRoutes.TRACKING_HOME });
        },

        toggleMenu(event?: MouseEvent) {
            if (event) {
                event.stopPropagation();
            }
            this.menuOpened = !this.menuOpened;
        },

        subscribeToClick() {
            document.addEventListener('click', this.onClick);
        },

        unsubscribeFromClick() {
            document.removeEventListener('click', this.onClick);
        },

        onClick() {
            if (this.menuOpened) {
                this.menuOpened = false;
            }
        },
    },
})
